export default {
    add: {
        title: 'Add a business',
    },
    analytics: {
        title: 'Analytics',
    },
    businessDetails: {
        adminView: 'Admin view',
        allBusinesses: 'All Businesses',
        editBusiness: 'Edit business',
        disable: 'Disable',
        enable: 'Enable',
        addBusiness: '+ Add a business',
        memberSince: 'Member since {{date}}',
        openToVisits: 'Open to visits',
        daysAWeek_one: '{{count}} day a week',
        daysAWeek_other: '{{count}} days a week',
        photosCount_one: '{{count}} photo',
        photosCount_other: '{{count}} photos',
        description: 'Description',
        photos: 'Photos',
        firstOneIsTheCover: 'first one is the cover',
        cover: 'Cover',
        contact: 'Contact',
        contactPerson: 'Contact person',
        email: 'Email',
        phone: 'Phone',
        website: 'Website',
        instagram: 'Instagram',
        address: 'Address',
        offerNumber: 'OFFER #{{number}}',
        storiesCount_one: '{{count}} story',
        storiesCount_other: '{{count}} stories',
        reelsCount_one: '{{count}} reel',
        reelsCount_other: '{{count}} reels',
        followersRequired: '{{count}} followers',
        closedToVisits: 'Closed to visits',
        noOffers: 'No offers yet',
        noAvailability: 'No availability set',
    },
    businessInReview: {
        title: 'Business In Review',
        message: 'Your business is currently under review. Please check back later for updates.',
    },
    businessName: 'Business Name',
    editBusiness: {
        editing: 'EDITING',
        unsavedChanges: 'Unsaved changes',
        saveChanges: 'Save changes',
        cancel: 'Cancel',
        fixErrors: 'Please fix the errors before saving',
        validationErrorTitle: 'Some details need fixing',
        validationErrorDescription: 'Fix the fields below, then save again.',
        invalidField: 'Something here needs fixing — open this step to see what',
        fields: {
            name: 'Business name',
            description: 'Description',
            place: 'Address',
            categories: 'Category',
            photos: 'Photos',
            offers: 'Offers',
            businessHours: 'Availability',
            contactPerson: 'Contact person',
            email: 'Email',
            phone: 'Phone',
        },
        addPhoto: 'Add photo',
        addPhotoTitle: 'Add photos',
        removePhoto: 'Remove photo',
        onSuccessAddPhoto: {
            title: 'Photos added',
            message: 'Your photos have been uploaded successfully.',
        },
        onSuccessDeletePhoto: {
            title: 'Photo deleted',
            message: 'The photo has been deleted successfully.',
        },
        switchLocaleHint: 'Switch to {{locale}} to edit the {{language}} version — both are required.',
        english: 'English',
        french: 'French',
        whatTheyGet: 'What they get',
        offerDescription: 'Description (optional)',
        offerDescriptionHint: 'Anything an influencer should know before claiming: conditions, what is not included, how to redeem.',
        influencerSize: 'Influencer size',
        storiesTheyPost: 'Stories they post',
        reelsTheyPost: 'Reels they post',
        addAnotherTier: '+ Add another tier',
        removeOffer: 'Remove offer',
        bothLanguagesRequired: 'Both English and French are required.',
        custom: 'Custom',
        customFollowerCount: 'Custom follower count',
        followersMinimum: 'followers minimum',
    },
    finishSetup: 'Finish Setup',
    home: {
        title: 'Home',
        message: 'Welcome to your business dashboard.',
        callout: 'Contact our team in order to change your available offers, business hours, or cover photos',
        businessDetails: 'Business Details',
        offers: 'Offers',
        messages: 'Messages',
    },
    newInfluencerRequest: 'New Influencer Request',
    newInfluencerRequests: 'New Influencer Requests',
    noNewRequestsForTheMoment: 'No new requests for the moment',
    onboarding: {
        noAccount: 'There is no professional account connected to this instagram. Make sure that you have the proper configurations',
        comeBackLater: 'Come back later !',
        selectAccount: {
            title: 'Select Instagram Account',
        },
        setupProfile: {
            title: 'Setup Your Profile',
            cta: 'Create Business Account',
        },
        confirm: {
            title: 'Welcome to the INVI experience !',
            message:
                'Please login and complete your business registration. Once completed, a member of the team will review your information and activate your account.',
        },
    },
    profilesNeedAttention: 'Profiles Need Attention',
    searchBy: 'Search by name, city or category',
    settings: {
        title: 'Settings',
    },
    status: {
        approved: 'Approved',
        pending: 'Pending',
        deleted: 'Deleted',
        draft: 'Draft',
    },
    businessOnboarding: {
        business: 'BUSINESS',
        welcome: {
            title: 'Welcome to INVI',
            subtitle: 'Join a community of influencers and make your business shine.',
            headline: 'Join a community of <highlight>influencers</highlight> and make <highlight>your business</highlight> <highlight>shine.</highlight>',
            highlights: {
                visibility: 'More visibility',
                collaborations: 'Simple collaborations',
                community: 'An engaged community',
            },
            tagline: 'Collaborations that make sense',
        },
        steps: {
            contact_and_address: 'Contact',
            category: 'Category',
            description: 'Description',
            photos: 'Photos',
            your_offers: 'Offers',
            availabilities: 'Availability',
        },
        titles: {
            contact_and_address: {
                title: 'Start with the essentials',
                subtitle: 'Add your contact details so creators can find you easily.',
            },
            category: {
                title: 'Category',
                subtitle: 'Select the category or categories that best describe your business.',
            },
            description: {
                title: 'Describe your business',
                subtitle: 'Tell us about your business and what makes it unique.',
            },
            photos: {
                title: 'Photos',
                subtitle: 'Add photos of your business. The first photo will be the main photo.',
            },
            your_offers: {
                title: 'Offers',
                subtitle: 'Set up your first offer for influencers.',
            },
            availabilities: {
                title: 'Availability',
                subtitle: 'Choose the days your business is open to collaborations.',
            },
        },
        contact: {
            cardTitle: 'Let’s start with the basics',
            cardSubtitle: 'It takes less than a minute. You can change everything later.',
            name: { label: 'Business name', placeholder: 'E.g. Café Olimpico' },
            email: { label: 'Email address', placeholder: 'contact@cafeolimpico.com' },
            phone: { label: 'Phone number', placeholder: '514 555-5555' },
            website: { label: 'Website', placeholder: 'https://www.yourwebsite.com' },
            instagram: { label: 'Instagram', placeholder: '@yourinstagramaccount' },
            address: {
                label: 'Main address',
                placeholder: 'E.g. 123 Saint-Laurent Blvd, Montréal, QC',
                hint: 'This is where your business will be shown to creators.',
            },
        },
        category: {
            cardTitle: 'Category',
            subtitle: 'Select the category or categories that best describe your business.',
        },
        description: {
            label: 'About your business',
            placeholder:
                'Describe your business, your concept, the atmosphere, the experiences and services you offer, and what sets you apart from the competition.',
            topics: {
                ambiance: 'Atmosphere',
                concept: 'Concept',
                services: 'Services',
                experience: 'Customer experience',
                strengths: 'Strengths',
            },
        },
        photos: {
            cardTitle: 'Photos',
            cardSubtitle: 'Add photos of your business. The first photo will be the main photo.',
            add: 'Add photos',
            formats: 'JPG, PNG (max 10 MB)',
            main: 'Main photo',
        },
        offers: {
            offer: 'Offer',
            category: 'Offer category',
            influencerSize: 'Influencer size',
            requestedContent: 'Requested content',
            story: 'Story',
            reel: 'Reel',
            reward: { label: 'Collaboration offer', placeholder: 'E.g. Free meal for 2' },
            description: {
                label: 'Offer description',
                optional: 'optional',
                placeholder: 'Add details, conditions, exclusions, etc.',
            },
            add: 'Add',
        },
        availabilities: {
            intro: 'Choose the days your business is open to collaborations.',
            closed: 'Closed to visits',
            opening: 'opening',
            closing: 'closing',
        },
        done: {
            stepLabel: 'Done',
            title: 'Your business is ready!',
            thanks: 'Thank you for joining INVI.',
            next: 'We will now review your information. You will receive a confirmation email shortly.',
            backToDashboard: 'Back to dashboard',
        },
        stepper: {
            copyTo: 'Copy to {{language}}',
        },
    },
    unfinishedProfiles: 'Unfinished Profiles',
    viewSubmission: 'View Submission',
    yourBusiness: 'Your businesses',
};
